import {
  IControl,
  IField,
  IFormPage,
} from 'app/services/api5-service/api.interface';

import { DynamicFormLayoutPlace } from '../model';

/**
 * Get field/control layout place
 *
 * @param control
 * @param field
 * @param page
 */
export function getLayoutPlace(
  control: IControl,
  field: IField,
  page?: IFormPage,
): DynamicFormLayoutPlace {
  switch (true) {
    case page?.$type === 'aside' || field.$type === 'aside':
      return 'aside';
    case control.$fixed === 'yes' || field.$fixed === 'yes':
      return 'header';
    default:
      return 'content';
  }
}
